<div class="update-card p-6 rounded-lg mb-4 bg-surface-800">
  <!-- Update Title - Always on top -->
  <h4 class="text-lg font-semibold text-white mb-4">{{ update.title }}</h4>

  <!-- Content Layout based on index -->
  <div [ngClass]="{
    'mb-4': true,
    'flex gap-4': index === 1,
    'block': index !== 1
  }">

    <!-- Image Container - Show for first two updates only -->
    @if (index <= 1 && update.coverImagePreview) { <div [ngClass]="{
      'flex-shrink-0': index === 1,
      'mb-4': index === 0,
      'mb-0': index === 1
    }">
      <img [src]="
          update.coverImagePreview
            ? (update.coverImagePreview.startsWith('data:') || update.coverImagePreview.startsWith('http') || update.coverImagePreview.startsWith('blob:')
                ? update.coverImagePreview
                : (update.coverImagePreview | adminImageSrc: projectId : {}))
            : null
        " [alt]="update.title" [ngClass]="{
          'w-full h-48': index === 0,
          'w-32 h-32': index === 1,
          'object-cover rounded-lg': true
        }" />
  </div>
  } @else if (index <= 1) { <!-- Image Placeholder for first two updates -->
    <div [ngClass]="{
      'flex-shrink-0': index === 1,
      'mb-4': index === 0,
      'mb-0': index === 1,
      'bg-gray-700 rounded-lg flex items-center justify-center': true,
      'w-full h-48': index === 0,
      'w-32 h-32': index === 1
    }">
      <i [ngClass]="{
        'pi pi-image text-gray-400': true,
        'text-4xl': index === 0,
        'text-2xl': index === 1
      }"></i>
    </div>
    }

    <!-- Text Content -->
    <div [ngClass]="{
      'flex-1': index === 1,
      'block': index !== 1
    }">
      <p [ngClass]="{
        'text-gray-300 leading-relaxed': true,
        'line-clamp-3': index === 0 || index > 1,
        'line-clamp-4': index === 1
      }">{{ update.text }}</p>
    </div>
</div>

<!-- Bottom row with action buttons and date -->
<div class="flex justify-between items-center mt-4 pt-4 border-t border-gray-700">
  <!-- Action Buttons on the left -->
  <div class="flex gap-2">
    <p-button icon="pi pi-pencil" [rounded]="true" size="small" (onClick)="onEdit()"
      [ariaLabel]="'projectEdit.updates.editUpdate' | translate"
      [title]="'projectEdit.updates.editUpdate' | translate" />
    <p-button icon="pi pi-trash" [rounded]="true" size="small" severity="danger" (onClick)="onRemove()"
      [ariaLabel]="'projectEdit.updates.removeUpdate' | translate"
      [title]="'projectEdit.updates.removeUpdate' | translate" />
  </div>

  <!-- Publish Date on the right -->
  <p class="text-sm text-gray-400">
    {{ update.publishDate | date:'dd/MM/yyyy' }}
  </p>
</div>
</div>
